import * as IdbKeyVal from "idb-keyval";
import ISimulator from '../classes/ISimulator';
import TrackMan2 from '../classes/TrackMan2';
import Foresight from '../classes/ForeSight';

export type SimulatorType = "TrackMan" | "Foresight" | "";

export default class SimulatorConfiguration{
    //note: deviceId is a unique ID for each location device. Right now I'm creating a Guid if it doesn't exist and will replace with TM Id if I can get that info
    constructor(public modelType: SimulatorType = "TrackMan", public connectionType = "WiFi", public ethernetAddress = "", public wifiAddress = "", public deviceId = "") {}
}

export const getSimulator = async (simulatorConfiguration: SimulatorConfiguration | undefined = undefined) => {
    if (simulatorConfiguration === undefined){
        simulatorConfiguration = await getConfiguration();
    }
    let simulator: ISimulator;

    switch (simulatorConfiguration!.modelType){
        case "TrackMan":
            simulator = new TrackMan2();
            break;
        case "Foresight":
            simulator = new Foresight();
            break;
    }
    return simulator!;
}

export const saveConfiguration = async (simulatorConfiguration: SimulatorConfiguration) => {
    await IdbKeyVal.set('simulatorConfiguration', simulatorConfiguration);
}

export const getConfiguration = async () => {
    let simulatorConfiguration = new SimulatorConfiguration();
    const response = await IdbKeyVal.get<SimulatorConfiguration>('simulatorConfiguration');
    if (response) {
        simulatorConfiguration = response;
    }
    return simulatorConfiguration;
}





